import { render, staticRenderFns } from "./MyProject.vue?vue&type=template&id=1ef423af&scoped=true&"
import script from "./MyProject.vue?vue&type=script&lang=js&"
export * from "./MyProject.vue?vue&type=script&lang=js&"
import style0 from "./MyProject.vue?vue&type=style&index=0&id=1ef423af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef423af",
  null
  
)

export default component.exports